
import objectPath from 'object-path'
import API from '@/api'
import { capitalize } from '@/utils/helpers'
import router from '@/router'

const actions = {
  getCart({ dispatch, commit, getters }, { id, service, query }) {
    commit('setTouristsRooms', query.rooms)
    commit('setTourists', {
      numberOfTourists: getters.getNumberOfTourists.total
    })

    if (service === 'hotels') {
      const {
        checkInDate: startDate,
        duration
      } = query

      commit('setDates', {
        startDate,
        endDate: null,
        duration
      })

      dispatch('getHotel', {
        id,
        query,
        hotelIndex: 0
      })
    }

    if (service === 'tours') {
      const {
        checkInDate: startDate,
        duration,
        tourResearchForm
      } = query

      commit('setDates', {
        startDate,
        endDate: null,
        duration
      })

      commit('setTourResearchForm', tourResearchForm)

      commit('setTourForm', query)

      dispatch('getTour', { id, query })
    }
  },
  booking({ commit }, payload) {
    API.cart.booking(payload)
      .then(({ data: { data: { orderId } } }) => {
        commit('changeBookingLoadingStatus', false)

        router.push({
          name: 'Order',
          params: {
            orderId
          }
        })
      })
      .catch(({ data: { errors } }) => {
        commit('changeBookingLoadingStatus', false)

        const touristsErrors = errors.map((error) => {
          const target = error.source.split('.')
          target.splice(0, 1)

          const [
            id,
            field
          ] = target

          return {
            field: `${field}${id}`,
            message: error.detail
          }
        })

        commit('setBookingErrors', touristsErrors)
      })
  },
  getServicePenalties({ commit, state }, payload) {
    const {
      ids,
      serviceName,
      apiModuleName,
      target
    } = payload

    const params = {
      ...ids,
      currency: this.getters['cart/getCartPrice'].currency
    }

    API[apiModuleName][`get${capitalize(serviceName)}Penalties`](params)
      .then(({ data: { data: { results } } }) => {
        if (objectPath.get(state, `${target}.penalties.hasError`)) {
          commit('setServiceModuleErrors', {
            target: `${target}.penalties`,
            status: false,
            errors: []
          })
        }

        commit(`set${capitalize(serviceName)}Penalties`, {
          target,
          penalties: results
        })

        if (results.length === 0) {
          commit('setServiceModuleErrors', {
            target: `${target}.penalties`,
            status: true,
            errors: ['Невозможно загрузить штрафы!']
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `${target}.penalties`
        })

        commit('setServiceModuleErrors', {
          target: `${target}.penalties`,
          status: true,
          errors
        })
      })
  },
  getServicePenaltiesForAll({ commit }, payload) {
    const {
      ids,
      serviceName,
      serviceId,
      apiModuleName,
      label
    } = payload

    API[apiModuleName][`get${capitalize(serviceName)}Penalties`](ids)
      .then(({ data: { data: { results } } }) => {
        if (results.length === 0) {
          commit('setServiceToAllPenalties', {
            service: serviceName,
            serviceId,
            collection: [],
            hasError: true,
            errors: [{ detail: 'Невозможно загрузить штрафы!' }],
            label
          })
        } else {
          commit('setServiceToAllPenalties', {
            service: serviceName,
            serviceId,
            collection: [...results],
            hasError: false,
            errors: [],
            label
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('setServiceToAllPenalties', {
          service: serviceName,
          serviceId,
          collection: [],
          hasError: true,
          errors,
          label
        })
      })
  },
}

export default actions